// 定义一个混入对象
import { mapGetters } from "vuex";

const userMixin = {
  created: function() {

  },
  methods: {},
  computed: {
    ...mapGetters("user", ["isBrandUser"])
  }
};

export default userMixin;